<header class="header-hld header-invison">


    <!-- Header Bottom Start -->
    <section class="header-bot ">
      <div class="container">
        <div class="row">
          <div class="col-9">
            <a href="javascript:void(0)" title="Sanlam" class="logo-hld" [routerLink]="'/register'">
                        <app-logo size="large" width="202" height="43" viewBox="0 0 203 44" fill="none"></app-logo>
            </a>
          </div>
        </div>
      </div>
    </section>
    <!-- Header Bottom Start -->

  </header>

<section class="register ">
    <div class="container">
        <div class="login-hld">
            <div class="d-flex flex-wrap align-items-stretch">
                <div class="col-lg-6 col-md-7 px-3 regsterfrm">
                    <!---1st step-->
                    <form class="send-OTP mb-4" *ngIf="showSendOTPSection">
                        <h2 class="mx-md-0 pt-md-0 caption bottomline mt-0">Get your <b class="font-bolder"> One-Time Pin (OTP)</b> via SMS</h2>
                        <p class="text-start px-md-0 mt-md-2 mt-0">We will send OTP to your registered cellphone number.</p>
                        <div class="login-bg form-inline mt-4">
                            <div class="required mb-md-0 col-md-10 col-12 px-0 inputspcemobile">
                                <div class="form-field gi-hld mb-3 position-relative">
                                    <input id="CellNumber" type="tel" readonly class="form-control" placeholder="" value="{{phoneNumber}}">
                                    <label for="CellNumber">Cell Number</label>
                                </div>
                                <div class="form-group fullwidth w-100 pt-0 mb-2 justify-content-between">
                                    <button class="btnregister w-100" (click)="sendOtp(1, 'otpSent')" name ="SendOtpButtonOnOTP" id="Send OTP_btn"> Send OTP </button>
                                </div>
                            </div>
                        </div>
                    </form>
                    <!---2nd step-->
                    <form class="send-OTP mb-4" *ngIf="showOtpValidateSection" [formGroup]="otpForm" (ngSubmit)="validateOtp()">
                        <h2 class="mx-md-0 pt-md-0 caption bottomline mt-0"><b class="font-bolder"> Enter </b> your OTP</h2>
                        <p class="text-start px-md-0 mt-md-2 mt-0">Please enter your OTP</p>

                        <div class="login-bg form-inline mt-4">
                            <div class="required mb-md-0 col-md-10 col-12 px-0 inputspcemobile">
                                <div *ngIf="otpErrorMsg!=''" class="alert alert-danger alertboxSetTime" role="alert">
                                    {{otpErrorMsg}}
                                </div>
                                <div *ngIf="successMsg!=''" class="alert alert-success" role="alert">
                                    {{successMsg}}
                                </div>
                                <div *ngIf="successMsgWithPipe == true" class="alert alert-success" role="alert">
                                    Your session will expire in {{counter | formatime}}.
                                </div>
                                <div class="form-field text-center mb-3">
                                    <div class="passcode-wrapper">
                                        <input id="otp1" type="tel" formControlName="OtpOne" inputmode="numeric" autocomplete="one-time-code"
                                            maxlength="6" (keyup)="onKeyUpEvent($event, 1)" (focus)="onFocusEvent(1)" (input)="monitorOtpAutofill($event)">
                                        <input id="otp2" type="tel" formControlName="OtpTwo" inputmode="numeric" autocomplete="one-time-code"
                                            maxlength="1" (keyup)="onKeyUpEvent($event, 2)" (focus)="onFocusEvent(2)">
                                        <input id="otp3" type="tel" formControlName="OtpThree" inputmode="numeric" autocomplete="one-time-code"
                                            maxlength="1" (keyup)="onKeyUpEvent($event, 3)" (focus)="onFocusEvent(3)">
                                        <input id="otp4" type="tel" formControlName="OtpFour" inputmode="numeric" autocomplete="one-time-code"
                                            maxlength="1" (keyup)="onKeyUpEvent($event, 4)" (focus)="onFocusEvent(4)">
                                        <input id="otp5" type="tel" formControlName="OtpFive" inputmode="numeric" autocomplete="one-time-code"
                                            maxlength="1" (keyup)="onKeyUpEvent($event, 5)" (focus)="onFocusEvent(5)">
                                        <input id="otp6" type="tel" formControlName="OtpSix" inputmode="numeric" autocomplete="one-time-code"
                                            maxlength="1" (keyup)="onKeyUpEvent($event, 6)" (focus)="onFocusEvent(6)">
                                    </div>
                                    <div class="invalid-feedback otpErrRequired">
                                        <div *ngIf="(otpFormControls.OtpOne.touched && otpFormControls.OtpOne.errors)" class="invalid-feedback">
                                            <div *ngIf="otpFormControls.OtpOne.errors.required"></div>
                                            <div *ngIf="otpFormControls.OtpOne.errors.minlength">OTP must be 6 digits</div>
                                        </div>
                                        <div *ngIf="(otpFormControls.OtpTwo.touched && otpFormControls.OtpTwo.errors)" class="invalid-feedback">
                                            <div *ngIf="otpFormControls.OtpTwo.errors.required"></div>
                                            <div *ngIf="otpFormControls.OtpTwo.errors.minlength">OTP must be 6 digits</div>
                                        </div>
                                        <div *ngIf="(otpFormControls.OtpThree.touched && otpFormControls.OtpThree.errors)" class="invalid-feedback">
                                            <div *ngIf="otpFormControls.OtpThree.errors.required"></div>
                                            <div *ngIf="otpFormControls.OtpThree.errors.minlength">OTP must be 6 digits</div>
                                        </div>
                                        <div *ngIf="(otpFormControls.OtpFour.touched && otpFormControls.OtpFour.errors)" class="invalid-feedback">
                                            <div *ngIf="otpFormControls.OtpFour.errors.required"></div>
                                            <div *ngIf="otpFormControls.OtpFour.errors.minlength">OTP must be 6 digits</div>
                                        </div>
                                        <div *ngIf="(otpFormControls.OtpFive.touched && otpFormControls.OtpFive.errors)" class="invalid-feedback">
                                            <div *ngIf="otpFormControls.OtpFive.errors.required"></div>
                                            <div *ngIf="otpFormControls.OtpFive.errors.minlength">OTP must be 6 digits</div>
                                        </div>
                                        <div *ngIf="(otpFormControls.OtpSix.touched && otpFormControls.OtpSix.errors)" class="invalid-feedback">
                                            <div *ngIf="otpFormControls.OtpSix.errors.required">OTP is required</div>
                                            <div *ngIf="otpFormControls.OtpSix.errors.minlength">OTP must be 6 digits</div>
                                        </div>
                                    </div>
                                </div>
                                <div class="form-field text-center mb-3">
                                    <p class="text-center mb-5">OTP sent to {{numberMasking}}</p>

                                </div>

                                <div class="form-group fullwidth w-100 pt-0 mb-2 justify-content-between">
                                    <button class="btnregister w-100" type="submit" name="OtpPageSubmitbutton" id="OTPSubmit_btn"> Submit </button>
                                </div>
                        
                                <div class="form-field text-center mb-3">
                                    <button 
                                    type="button"
                                     name="ResendOtpButtonOnOTP" 
                                     (click)="sendOtp(1, 'otpReSent')" 
                                     class="resendlink" id="Resend OTP_btn"
                                     *ngIf="sendOtpText =='Resend SMS OTP' && hideResendOTPButton == false"
                                     [ngStyle]="disableOTPSendButton == true ? {'border-color': '#767272','color': '#767272', 'opacity': '0.7'} : {'border-color': '#0075c9','color': '#0075c9'}"
                                     [disabled]="disableOTPSendButton">Resend OTP <span *ngIf="secondsLeft > 0">in {{secondsLeft}}s</span></button>
                                </div>
                            </div>
                        </div>
                    </form>

                    <!--mobile Image-->
                    <figure class="m-0 d-block d-md-none">
                        <div class="bgmg position-relative">
                            <img ngOptimizedImage  src="../../assets/images/registerimg.jpg" class="ps-md-5" alt="" />
                        </div>
                    </figure>
                </div>
                <div
                    class="col-lg-6 col-md-5 col-12 d-flex flex-wrap pt-lg-3 ps-lg-5 ps-3 pe-lg-3 pe-3 boxblue align-items-stretch">
                    <app-need-help></app-need-help>
                </div>
            </div>

        </div>
    </div>
</section>
<app-footer></app-footer>
